export default {
  bill: {
    Componentontheleft: {
      a1: '已出帐',
      a2: '未出账',
      a3: '历史账单'
    },
    heard: {
      search: '请输入供应商查询',
      wholeO: '全选'
    },
    table: {
      documentType: '来源单据类型',
      sourceType: '单据类型',
      jointConfirmation: '双方已确认',
      siteName: '采购中心',
      plantName: '工厂',
      orderType: '订单性质',
      uniNo: '订单项次-项序-分批序',
      unitName: '采购单位',
      valuationUnitName: '计价单位',
      invoiceQty: '计价数量',
      invoicedQty: '已开票数量',
      taxPrice: '含税单价',
      taxAmount: '含税金额',
      payTermsName: '付款条件名称',
      priceConditionName: '价格条件名称',
      taxTypeName: '税种名称',
      taxRate: '税率(%)',
      currencyName: '币种名称',
      warehouseName: '仓库名称',
      documentOptions: {
        '1': '入库',
        '2': '退货'
      },
      purchaseUnitName: '采购中心',
      purchaseUnitNo: '采购中心',
      looktotal: '查看合计',
      costDate: '费用日期',
      purchaseNo: '订单号',
      discrepantdata: '详细数据',
      xiangqingData: '详情数据',
      pucsscxx: '采购单项次',
      goodsNo: '料号',
      goodsName: '品名',
      batchPurQty: '采购数量',
      sourceSeq: '来源项次',
      asnNo: '送货单号',
      asnSeq: '送货单项次',
      deliveryQty: '送货数量',
      receiveQty: '收货数量',
      checkReturnQty: '验退数量',
      inStoreQty: '入库/仓退数量',
      chacuo: '差错类别',
      minPurTaxPrice: '最小采购含税单价',
      purTaxAmount: '采购含税金额',
      PurTaxPrice: '采购单价(未税)',
      purNoTaxAmount: '采购未税金额',
      unInvoiceQty: '可开票/对账数量',
      // =====
      minStoreUnTaxPrice: '入库未税单价',
      storeNoTaxAmount: '入库未税金额',
      minStoreTaxPrice: '入库含税单价',
      storeTaxAmount: '入库含税金额',
      // =====
      supplierName: '供应商',
      duizhang: '对账状态',
      duizhangOptions: {
        'Y-N': '采购商已确认',
        'N-Y': '供应商已确认',
        'Y-Y': '双方已确认',
        'N-N': '双方未确认'
      },
      kaipiao: '开票状态',
      opction: '操作',
      lookinfo: '查看详情',
      OK: '确认',
      NOOK: '取消确认',
      yikaipiao: '已开票',
      weikaipiao: '未开票',
      pucssyes: '采购商已确认',
      supyes: '供应商已确认',
      myheNo: '双方未确认',
      myheyes: '双方已确认',
      normality: '正常数据',
      abnormal: '异常数据',
      all: '全部',
      noaffirm: '未确认',
      yesaffirm: '已确认',
      palce: '订单单号/来源单号',
      pucsszhongx: '采购中心',
      sourceNo: '来源单号',
      goData: '开始日期',
      endData: '结束日期',
      keyword: '订单号',
      datadifference: ['正常数据', '异常数据'],
      cuttabs: ['明细', '总览'],
      invoiceSign: '仅查看未开票数据',
      import: '导出对账单',
      manual: '批量确认',
      yesnoOk: '是否进行操作',
      yesnoNOOk: '是否取消确认',
      diffSign: '仅显示差异数据',
      dayin: '对账明细信息',
      fafangbtn: '是否发放',
      manualDisabled: '已经确认的订单无法再次确认',
      allSumTitle: '汇总条件',
      dateRange: '费用产生时间',
      spec: '规格',
      diffReasonWarning: '请输入差异原因！'
    },
    costdetail: {
      costDate: '费用类型',
      sourceNo: '来源单号',
      sourceSeq: '来源单项次',
      costType: '费用类型',
      supplierName: '供应商',
      feiyongDate: '费用时间',
      goodsName: '品名',
      goodsNo: '料号',
      diffAmount: '税额',
      taxAmount: '对账金额(含税)',
      invoiceQty: '对账数量(入库/退货)',
      unInvoiceQty: '剩余未开数量'
    },
    addfapiao: {
      searchPlaceholder: '请输入品名/料号/供应商',
      startDate: '开票开始时间',
      endDate: '开票结束时间',
      supplierName: '供应商名称',
      purchaseNo: '订单单号',
      goodsName: '料号'
    },
    text: { // 别的页面用的，不要用这个
      lookokdata: '查看已确认未抛转数据',
      placeholdertext: '请输入发票号查询',
      billNo: '单据编号',
      invoiceNo: '单据编号',
      adddate: '开票时间',
      supOfficeNo: '供应商编号',
      lookbohuiinfo: '查看驳回原因',
      luru: '录入',
      chongxluru: '重新录入',
      supOfficeName: '供应商名称',
      allTaxAmount: '税额',
      status: '发票状态',
      userName: '发起人',
      throwStatus: '抛转状态',
      invoiceStartDate: '开票开始时间',
      invoiceEndDate: '开票结束时间',
      costType: '费用类型',
      purchaseNo: '订单单号',
      asnNo: '送货单号',
      goodsNo: '料件编号',
      sourceNo: '入库单号',
      status1: '待录入',
      status2: '待对票',
      status3: '已确认',
      status4: '已驳回',
      status5: '已作废',
      caozuo: '操作'
    },
    others: {
      statustabs: ['全部', '未确认', '已确认'],
      tabs: ['按供应商区分', '按料件汇总', '按订单汇总', '按发货单汇总'],
      dialog: {
        warnTitle: '差异建议线下沟通后，联系采购商修改来源单',
        entry: '条目',
        purchaseOrder: '采购单',
        receiptReturn: '入库/仓退单',
        priceNoTax: '单价（不含税）',
        priceTax: '单价（含税）',
        taxCategory: '税种',
        taxRate: '税率',
        purValuationQty: '计价数量',
        purAmount: '采购金额',
        source: '来源',
        storeSourceTypeName: '采购单',
        purSourceNo: '来源单号',
        purManageType: '处理方式',
        purPayTermsName: '付款条件',
        purPriceConditionName: '价格条件',
        diffReason: '差异原因',
        diffReasonPlaceholder: '请输入差异原因',
        invoicedQty: '已开票数量',
        unInvoiceQty: '未开票数量',
        ticketOptions: ['已开票', '未开票'],
        purCurrencyName: '币种'
      }
    }
  },
  invoice: {
    searchPlaceholder: '请输入发票号码搜索',
    invoiceNo: '发票号码',
    invoiceDate: '发票日期',
    invoiceClassify: '发票种类',
    invoiceType: '发票类型',
    invoiceAmount: '发票金额',
    taxRate: '税率（%）',
    taxAmount: '税额',
    invoiceCode: '发票代码',
    isGoodsInvoice: '是否随货发票',
    dateRange: '发票日期',
    invoiceClassifyName: ['纸质发票', '电子发票'],
    invoiceTypeName: ['普通发票', '增值税普通发票', '增值税专用发票'],
    isGoodsInvoiceName: ['是', '否']
  }
}
